'use client';

import { Button, VariantState, View } from '@bytel/trilogy-react-ts';

import { FaiProduct } from '@app-types/fai';
import { PlanType } from '@app-types/product';
import { TagEventType } from '@app-types/tracking';

import useTracking from '@hooks/use-tracking';

import TagAnimated from './home/animated-tag';

interface CtaAddToCartProps {
    selectedProduct?: FaiProduct | PlanType | null;
    temporarilySelectedProduct?: FaiProduct | PlanType | null;
    handleAddToCart: () => void;
    ctaLabel: {
        productAdded: string;
        productNotAdded: string;
        tagAdded: string;
    };
}

export function CtaAddToCart({
    selectedProduct,
    temporarilySelectedProduct,
    handleAddToCart,
    ctaLabel,
}: Readonly<CtaAddToCartProps>) {
    const { sendTag } = useTracking();

    const isSelectedProductFai = selectedProduct && 'gencode_offre' in selectedProduct;
    const isTemporarilySelectedProductFai = temporarilySelectedProduct && 'gencode_offre' in temporarilySelectedProduct;

    const productGencode = isSelectedProductFai ? selectedProduct?.gencode_offre : selectedProduct?.gencode;

    const temporarySelectedProductGencode = isTemporarilySelectedProductFai
        ? temporarilySelectedProduct?.gencode_offre
        : temporarilySelectedProduct?.gencode;

    const isProductAdded = productGencode === temporarySelectedProductGencode;

    return (
        <View className='cta-add-to-cart'>
            <TagAnimated label={ctaLabel.tagAdded} enable={isProductAdded} className='mb-4' />
            <Button
                variant={isProductAdded ? VariantState.TERTIARY : VariantState.PRIMARY}
                fullwidth
                className={isProductAdded ? '' : 'has-byou-background'}
                onClick={() => {
                    handleAddToCart();
                    if (!isProductAdded) {
                        sendTag(
                            {
                                actionClic: 'Clic_redirection',
                                categorieClic: 'Ajouter_au_panier',
                                nomClic:
                                    (isTemporarilySelectedProductFai
                                        ? temporarilySelectedProduct.range_ng
                                        : temporarilySelectedProduct?.url) ?? '',
                            },
                            TagEventType.CLICK,
                        );
                    }
                }}
                accessibilityLabel='Ajouter un forfait au panier'
                id='selectOffer'
            >
                {isProductAdded ? ctaLabel.productAdded : ctaLabel.productNotAdded}
            </Button>
        </View>
    );
}
